export { initProxySDK, getProxySDK } from './proxy';
/**
 * Returns the CommandBar global SDK.
 * The SDK object might be a proxy instead if `initSDK` has not yet been called.
 */
export function getSDK() {
    return window.CommandBar;
}
/**
 * Returns the CommandBar global, coerced to match the client interface.
 * The SDK object might be a proxy instead if `initSDK` has not yet been called.
 */
export function getClientSDK() {
    return window.CommandBar;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jbGllbnQvZ2xvYmFscy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBU0EsT0FBTyxFQUFFLFlBQVksRUFBRSxXQUFXLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFcEQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLE1BQU07SUFDcEIsT0FBTyxNQUFNLENBQUMsVUFBdUQsQ0FBQztBQUN4RSxDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLFlBQVk7SUFDMUIsT0FBTyxNQUFNLENBQUMsVUFBaUMsQ0FBQztBQUNsRCxDQUFDIn0=